import { render } from "./BabyDiary.vue?vue&type=template&id=271a68f8"
import script from "./BabyDiary.vue?vue&type=script&lang=js"
export * from "./BabyDiary.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__